module.exports = __webpack_public_path__ + "media/icons/4-700b5828.png";